import type React from 'react';
import { FormField, Label } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';
import { LAST_MONTH_RENT } from '../../../constants';
import { FEE_PAYMENT_TIME } from '../../../constants/stringConstants';
import FeePaymentTime_v2 from '../../Widgets/FeePaymentTime_v2';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function LastMonthRent_v3({ section, setSectionValues }: Props) {
  function onNoLastMonth() {
    setSectionValues({
      [LAST_MONTH_RENT.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesLastMonth() {
    setSectionValues({
      [LAST_MONTH_RENT.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onPayDueClick(event: React.ChangeEvent<HTMLInputElement>): void {
    const { id } = event.currentTarget;

    setSectionValues({
      [LAST_MONTH_RENT.FIELD_NAME.UPON_SIGNING]: id === FEE_PAYMENT_TIME.FIRST_PAY_ON_SIGN,
      [LAST_MONTH_RENT.FIELD_NAME.START_MOVE_IN_DATE]: id === FEE_PAYMENT_TIME.FIRST_PAY_ON_LEASE_START,
      [LAST_MONTH_RENT.FIELD_NAME.TWO_EQUAL_INSTALLMENTS]: id === FEE_PAYMENT_TIME.TWO_EQUAL_INSTALLMENTS,
      [LAST_MONTH_RENT.FIELD_NAME.THREE_EQUAL_INSTALLMENTS]: id === FEE_PAYMENT_TIME.THREE_EQUAL_INSTALLMENTS,
    });
  }

  return (
    <FormField
      required
      label={<Label>Will you collect the last month’s rent payment upfront?</Label>}
      disabled={section.isFieldDisabled(LAST_MONTH_RENT.FIELD_NAME.IS_ENABLED)}
      control={
        <YesAndNoExpansion
          yesHandler={onYesLastMonth}
          noHandler={onNoLastMonth}
          yesActive={section.getFieldValue(LAST_MONTH_RENT.FIELD_NAME.IS_ENABLED)}
          disabled={section.isFieldDisabled(LAST_MONTH_RENT.FIELD_NAME.IS_ENABLED)}
        >
          <FeePaymentTime_v2
            label="When is last month rent due?"
            section={section}
            onChange={onPayDueClick}
            firstChecked={section.getFieldValue(LAST_MONTH_RENT.FIELD_NAME.UPON_SIGNING)}
            secondChecked={section.getFieldValue(LAST_MONTH_RENT.FIELD_NAME.START_MOVE_IN_DATE)}
            thirdChecked={section.getFieldValue(LAST_MONTH_RENT.FIELD_NAME.TWO_EQUAL_INSTALLMENTS)}
            fourthChecked={section.getFieldValue(LAST_MONTH_RENT.FIELD_NAME.THREE_EQUAL_INSTALLMENTS)}
            firstField={LAST_MONTH_RENT.FIELD_NAME.UPON_SIGNING}
            secondField={LAST_MONTH_RENT.FIELD_NAME.START_MOVE_IN_DATE}
            thirdField={LAST_MONTH_RENT.FIELD_NAME.TWO_EQUAL_INSTALLMENTS}
            fourthField={LAST_MONTH_RENT.FIELD_NAME.THREE_EQUAL_INSTALLMENTS}
          />
        </YesAndNoExpansion>
      }
    />
  );
}

LastMonthRent_v3.description = 'Additional payment timing for WA';

export default LastMonthRent_v3;
